<template>
	<div id="musicPlayer">
		<input type="image" class="sound-button" v-bind:src="btnImage" v-on:click="btnClick()" />
		<audio v-bind:id="'myAudio' + config.id" type="audio/mpeg" loop Your browser does not support the audio element.></audio>
	</div>
</template>

<script>
export default {
	name: "MusicPlayer",
	props: {
		config: Object
	},
	data: () => ({
		myTrack: null,
		imgMuteOn: null,
		imgMuteOff: null,
		playing: false,
		btnImage: null,
		myAudio: null,
		firstTime: true
	}),
	mounted() {
		this.myTrack = this.config.mp3;
		this.imgMuteOn = this.config.imgMuteOn;
		this.imgMuteOff = this.config.imgMuteOff;
		this.myAudio = document.getElementById("myAudio" + this.config.id);
		this.myAudio.volume = "0.1";
		this.myAudio.autoplay = true;
		this.myAudio.src = this.myTrack;
		this.playing = false;
		this.btnImage = this.imgMuteOff;
		this.playAudio();
	},
	methods: {
		btnClick() {
			this.firstTime = false;
			this.playAudio();
		},
		playAudio() {
			if (!this.firstTime) {
				if (this.playing) {
					this.playing = false;
					this.myAudio.pause();
					this.btnImage = this.imgMuteOff;
				} else {
					this.playing = true;
					this.myAudio.loop = true;
					this.myAudio.play();
				}
			}
			this.myAudio.addEventListener("play", () => {
				this.playing = true;
				if (this.firstTime) {
					this.firstTime = false;
				}
				this.btnImage = this.imgMuteOn;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/constants";
.sound-button {
	border: none;
	display: block;
	position: relative;
	height: 100%;
	width: 100%;
	cursor: pointer;
}
</style>
